<div class="flex flex-col gap-3 mb-5">
  <div class="flex flex-col md:flex-row gap-3">
    <div class="flex-1 md:flex gap-3 items-center">
      <div class="grid grid-cols-4 md:flex gap-3">
        <ui-button
          [mode]="granularity() === 'YEAR' ? 'filled' : 'outlined'"
          (click)="onChangeFilter({ granularity: 'YEAR' })"
          size="small"
          class="flex-none"
          expand="full"
          data-track="price-granularity-year"
        >
          {{ 'cockpit.analysis.hpfc.detail.granularityYear' | transloco }}
        </ui-button>
        <ui-button
          [mode]="granularity() === 'MONTH' ? 'filled' : 'outlined'"
          (click)="onChangeFilter({ granularity: 'MONTH' })"
          size="small"
          class="flex-none"
          expand="full"
          data-track="price-granularity-month"
        >
          {{ 'cockpit.analysis.hpfc.detail.granularityMonth' | transloco }}
        </ui-button>
        <ui-button
          [mode]="granularity() === 'WEEK' ? 'filled' : 'outlined'"
          (click)="onChangeFilter({ granularity: 'WEEK' })"
          size="small"
          class="flex-none"
          expand="full"
          data-track="price-granularity-week"
        >
          {{ 'cockpit.analysis.hpfc.detail.granularityWeek' | transloco }}
        </ui-button>
        <ui-button
          [mode]="granularity() === 'DAY' ? 'filled' : 'outlined'"
          (click)="onChangeFilter({ granularity: 'DAY' })"
          size="small"
          class="flex-none"
          expand="full"
          data-track="price-granularity-day"
        >
          {{ 'cockpit.analysis.hpfc.detail.granularityDay' | transloco }}
        </ui-button>
      </div>
      <div class="hidden lg:flex items-center">
        <ui-toggle-label class="h-[24px]" data-track="price-toggle-eur-mwh">
          <ui-toggle [checked]="showEurMwh()" (checkedChange)="onToggleEurMwh($event)" />
          {{ 'cockpit.analysis.hpfc.detail.showEurMwh' | transloco }}
        </ui-toggle-label>
      </div>
    </div>
    <ui-button
      mode="outlined"
      size="small"
      class="flex-none hidden md:block"
      (click)="onClickTodayButton()"
      data-track="price-date-today-button"
    >
      {{ 'cockpit.analysis.hpfc.detail.today' | transloco }}
    </ui-button>
    <div class="flex-none w-full md:w-[244px] flex gap-2">
      <ui-button
        mode="outlined"
        size="small"
        [iconOnly]="true"
        class="flex-none"
        [disabled]="isPreviousDisabled()"
        (click)="onClickPreviousButton()"
        data-track="price-date-prev-button"
      >
        <ng-icon name="heroChevronLeft" size="20" class="!block" />
      </ui-button>
      <div class="flex-1 flex items-center justify-center text-sm" data-track="price-date-display">
        @switch (filter().granularity) {
          @case ('YEAR') {
            {{ filter().date | date: 'yyyy' }}
          }
          @case ('MONTH') {
            {{ filter().date | date: 'MMMM yyyy' }}
          }
          @case ('WEEK') {
            {{ selectedFrom() | date: 'dd.MM.' }} -
            {{ selectedTo() | date: 'dd.MM.yyyy' }}
          }
          @case ('DAY') {
            {{ filter().date | date: 'cccc dd.MM.yyyy' }}
          }
        }
      </div>
      <ui-button
        mode="outlined"
        size="small"
        [iconOnly]="true"
        class="flex-none"
        [disabled]="isNextDisabled()"
        (click)="onClickNextButton()"
        data-track="price-date-next-button"
      >
        <ng-icon name="heroChevronRight" size="20" class="!block" />
      </ui-button>
    </div>
  </div>
</div>
